import { all, fork } from 'redux-saga/effects';
import auth from './auth';
import apiDocs from './api-docs';
import site from './site';
import membership from './membership';
import defaultApis from './default-apis';
import serviceDirectory from './service-directory';
import countryInformation from './country-information';
import htmls from './htmls';

const rootSaga = function* root() {
  yield all([
    fork(auth),
    fork(apiDocs),
    fork(site),
    fork(membership),
    fork(defaultApis),
    fork(serviceDirectory),
    fork(countryInformation),
    fork(htmls),
  ]);
};

export default rootSaga;
